import { PaymentGatewaysService } from './../../services/hmp/payment-gateways/payment-gateways.service'
import { Injectable } from '@angular/core'
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  Resolve,
} from '@angular/router'
import { Observable } from 'rxjs'
import { Logger } from '../../logger.service'
import { map, catchError } from 'rxjs/operators'
import { Promotions } from '../../models'

const log = new Logger('PaymentGatewaysResolver')
@Injectable({ providedIn: 'root' })
export class PaymentGatewaysResolver
  implements Resolve<Observable<Promotions>> {
  constructor(
    private PGService: PaymentGatewaysService,
    private router: Router
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    let mode = route.params['mode']
    let _id = route.params['id']
    
    return this.PGService.getDetail(_id).pipe(
      map(data => {
        return data
      }),
      catchError(err => this.router.navigate(['/payment-gateways']))
    )
  }
}
